// extracted by mini-css-extract-plugin
module.exports = {"container":"licenses_container__1782x"};